import styled, { createGlobalStyle } from 'styled-components';
import dephiana from 'static/font/Dephiana.ttf';

export const Scroll = createGlobalStyle`
  ul, li {
    list-style: none;
  }

  /* width */
  ::-webkit-scrollbar {
    width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background: ${props => props.theme.scrollTrackBg}
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.5);
    box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background: ${props => props.theme.scrollThumbBg}
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: ${props => props.theme.scrollThumbBg}
  }

  @font-face {
    font-family: Dephiana;
    src: url(${dephiana});
  }
`;

export const MainContainer = styled.div`
  background: ${props => props.displayMenuName === "map" ? props.theme.mainMapBg : props.theme.mainInfoBg}
  background-size: cover;
`;